export const NAMED_VAR_RE = /^[a-z][a-z_]{0,63}$/;

const TOKEN_RE = /\{\{\s*([^{}\s]+)\s*\}\}/g;

export const extractTokens = (text) => {
  const out = [];
  for (const m of (text || '').matchAll(TOKEN_RE)) {
    if (!out.includes(m[1])) out.push(m[1]);
  }
  return out;
};

export const isNumericToken = (tok) => /^\d+$/.test(tok);

export const isNumberedTemplate = (template) => {
  const comps = Array.isArray(template?.components) ? template.components : [];
  return comps.some((c) => {
    const type = (c.type || '').toUpperCase();
    const textual = type === 'BODY' || (type === 'HEADER' && (c.format || 'TEXT').toUpperCase() === 'TEXT');
    return textual && extractTokens(c.text).some(isNumericToken);
  });
};

export const namedExamples = (component, key) => {
  const list = component?.example?.[key];
  const out = {};
  if (!Array.isArray(list)) return out;
  list.forEach((p) => {
    if (p && p.param_name) out[p.param_name] = p.example || '';
  });
  return out;
};

const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const replaceToken = (text, tok, value) =>
  (text || '').replace(new RegExp(`\\{\\{\\s*${escapeRe(tok)}\\s*\\}\\}`, 'g'), () => value);

export const validateVarNames = (tokens) => {
  for (const tok of tokens) {
    if (isNumericToken(tok)) {
      return `Las variables llevan nombre, no número: cambia {{${tok}}} por algo como {{nombre}}.`;
    }
    if (!NAMED_VAR_RE.test(tok)) {
      return `El nombre de variable {{${tok}}} no es válido: usa minúsculas y guiones bajos, empezando por letra.`;
    }
  }
  return null;
};
